export function homeUnauthorised() {
    const $elements = $('.tile_list-container, .login-landing');
    $elements.matchHeight();

    $(window).resize(function () {
        $elements.css('height', '').matchHeight();
    });
}
